import { useEffect, useState, Suspense, lazy } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Loader from "@/components/Loader";
import ScrollProgress from "@/components/ScrollProgress";
import Particles from "@/components/Particles";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import { Toaster } from "sonner";

const Home = lazy(() => import("@/pages/Home"));
const ContactPage = lazy(() => import("@/pages/ContactPage"));
const NotFound = lazy(() => import("@/pages/NotFound"));

function Shell({ children }) {
  return (
    <div className="App relative">
      <Particles />
      <ScrollProgress />
      <Navigation />
      <main className="relative z-[2]">{children}</main>
      <Footer />
      <Toaster theme="dark" position="bottom-center" richColors closeButton />
    </div>
  );
}

export default function App() {
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setLoaded(true), 1500);
    return () => clearTimeout(t);
  }, []);

  return (
    <BrowserRouter>
      {!loaded && <Loader />}
      <Suspense fallback={<Loader silent />}>
        <Routes>
          <Route
            path="/"
            element={
              <Shell>
                <Home />
              </Shell>
            }
          />
          <Route
            path="/contact"
            element={
              <Shell>
                <ContactPage />
              </Shell>
            }
          />
          <Route
            path="*"
            element={
              <Shell>
                <NotFound />
              </Shell>
            }
          />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
